<template>
  <div>
    <el-dialog title="批量下载" :close-on-click-modal="false" center :visible.sync="dowmShow" @close="handleClose"
      width="761px" class="dialog-wrap-dowm-nom">
      <div class="dialog-member-title">
        <span class="dialog-member-name">批量下载</span>
        <div class="dialog-close" @click="handleClose">
          <i class="el-icon-close"></i>
        </div>
      </div>

      <div class="dialog-nom-list" v-loading="uploadLoading || pageLoading">
        <div class="dialog-nom-list-left">
          <el-table :data="downList.data" ref="multipleTable" :header-cell-style="{
            backgroundColor: 'none',
            color: '#333',
            fontWeight: 'bold',
            textAlign: 'center',
            fontSize: '14px',
          }" height="470px" style="width: 390px" :cell-style="{ 'text-align': 'center' }" row-key="id"
            @selection-change="getUser">
            <el-table-column type="selection" width="55" :selectable="selectableFn"> </el-table-column>
            <el-table-column prop="applicantName" label="姓名">
            </el-table-column>
            <el-table-column prop="statusName" label="申请状态">
              <template slot-scope="scope">
                <div class="flex-app">
                  <div :style="setTopClass(scope.row.status)">
                    {{ scope.row.statusName }}
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <div class="table-pagination">
            <el-pagination @current-change="downCurrentChange" :current-page="downList.pageIndex"
              @size-change="downSizeChange" :page-size="downList.pageSize" :page-sizes="[10, 20, 50, 100, 1000]"
              layout="total, sizes,prev, pager, next, jumper" :pager-count="5" small :total="downList.total">
            </el-pagination>
          </div>
        </div>
        <div class="dialog-nom-list-right">
          <div class="dialog-nom-list-right-wrap">
            <div class="dialog-nom-list-right-title">
              <p>选择下载内容</p>
              <p>
                共选择<span>{{ userListAllTable.length }}本</span>签证
              </p>
            </div>
            <div class="dialog-nom-list-right-yello">
              <i class="el-icon-warning"></i>
              <span style="margin-left: 5px">若选择的申请人无相关资料，下载内容为空</span>
            </div>
            <div class="dialog-nom-select-up">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                @change="handleCheckAllChange">全选</el-checkbox>
              <div style="margin: 15px 0"></div>
              <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="city in cities" :label="city" :key="city">{{
                  city
                }}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>

      <div class="packge-btn-add" style="margin-top: 15px">
        <el-button class="pageck-btn" @click="handleClose">取消</el-button>
        <el-button v-preventReClick :disabled="uploadLoading" :loading="uploadLoading" class="pageck-btn default"
          type="primary" @click="submitDownLoadFn">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="downTitle" :close-on-click-modal="false" center :visible.sync="visible" @close="handleClose"
      width="425px" class="dialog-wrap-dowm-nom">
      <div class="dialog-member-title">
        <div class="dialog-member-name">
          {{ downTitle }}
          <span style="font-size: 12px">
            已选择<span style="color: #0094e8">{{
              userListAllTable.length
            }}</span>本</span>
        </div>
        <div class="dialog-close" @click="handleClose">
          <i class="el-icon-close"></i>
        </div>
      </div>

      <div class="dialog-nom-list" v-loading="submitLoading || pageLoading">
        <div class="dialog-nom-list-left">
          <el-table :data="downList.data" ref="multipleTable" :header-cell-style="{
            backgroundColor: 'none',
            color: '#333',
            fontWeight: 'bold',
            textAlign: 'center',
            fontSize: '14px',
          }" height="470px" style="width: 390px" :cell-style="{ 'text-align': 'center' }" row-key="id"
            @selection-change="getUser">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="applicantName" label="姓名">
            </el-table-column>
            <el-table-column prop="statusName" label="申请状态">
              <template slot-scope="scope">
                <div class="flex-app">
                  <div :style="setTopClass(scope.row.status)">
                    {{ scope.row.statusName }}
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <!-- <div class="table-pagination">

                        <el-pagination @current-change="addressCurrentChange" :current-page="downList.pageIndex"
                            :page-size="downList.pageSize" layout="total, prev, pager, next, jumper" :pager-count="5" small
                            :total="downList.total">
                        </el-pagination>
                    </div> -->
        </div>
        <!-- <div class="dialog-nom-list-right">
                    <div class="dialog-nom-list-right-wrap">

                        <div class="dialog-nom-list-right-title">
                            <p>选择下载内容</p>
                            <p>共选择<span>15本</span>签证</p>
                        </div>
                        <div class="dialog-nom-list-right-yello">
                            <i class="el-icon-warning"></i>
                            <span style="margin-left: 5px;">若选择的申请人无相关资料，下载内容为空</span>
                        </div>
                        <div class="dialog-nom-select-up">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                                @change="handleCheckAllChange">全选</el-checkbox>
                            <div style="margin: 15px 0;"></div>
                            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                                <el-checkbox v-for="city in cities" :label="city" :key="city">{{ city }}</el-checkbox>
                            </el-checkbox-group>

                        </div>
                    </div>
                </div> -->
      </div>

      <div class="packge-btn-add" style="margin-top: 15px">
        <el-button class="pageck-btn" @click="handleClose">取消</el-button>
        <el-button v-preventReClick :disabled="submitLoading" :loading="submitLoading" class="pageck-btn default"
          type="primary" @click="confirmSubmit">确认</el-button>
      </div>
    </el-dialog>
    <!-- 提交大使馆 -->
    <batchApplicationSubmit :visible="submitApplicationShow" :orderId="orderId" :isBatch="isBatch"
      :length="userListAllTableLength" @confirm="confirmSubmitFn" @close="submitApplicationShow = false">
    </batchApplicationSubmit>

    <el-dialog class="dialog-wrap-dowm-nom" center :visible.sync="downloadTypeDialog" width="360px" :close-on-click-modal="false">
      <div class="dialog-member-title" style="margin-bottom: 15px;">
        <div class="dialog-member-name">选择命名方式</div>
      </div>
      <el-radio-group v-model="downloadType">
        <el-radio :label="0" style="display: block; margin-bottom: 10px;">默认</el-radio>
        <el-radio :label="1" style="display: block; margin-bottom: 10px;">护照号</el-radio>
        <el-radio :label="2" style="display: block; margin-bottom: 10px;">拼音名</el-radio>
        <el-radio :label="3" style="display: block;">中文名+护照号</el-radio>
      </el-radio-group>
      <div class="packge-btn-add" style="margin-top: 15px;display: flex;justify-content: center;">
        <el-button class="pageck-btn" @click="cancelDownloadType">取消</el-button>
        <el-button class="pageck-btn default" type="primary" @click="confirmDownloadType">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { sendemailvisa } from "@/api/product.js";
import { queryorderapplicants, batchcancelvfsorder, downloadapplicantsdata } from "@/api/order.js";
const cityOptions = ["收据页", "签证文件", "拒签信"];
import { export_json_to_excel } from '@/utils/Export2Excel';

import batchApplicationSubmit from './batchApplicationSubmit.vue'

export default {
  components: { batchApplicationSubmit },
  props: {
    dowmShow: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    downTitle: {
      type: String,
      default: '批量'
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    orderDetail: {
      type: [Object],
      default: () => { }
    },
  },
  data() {
    return {
      pageLoading: false,
      uploadLoading: false,
      submitLoading: false,
      userListAllTable: [],
      userListAllTableLength: 0,
      applicantstatusTimer: '',


      emailInfo: {
        visible: false,
        email: null,
      },

      checkAll: true,
      isIndeterminate: false,
      cities: cityOptions,
      checkedCities: cityOptions,
      downList: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
        data: [],
        title: ''
      },

      // 批量提交申请支付
      submitApplicationShow: false,
      // 批量提交
      isBatch: true,
      listLength: 0,
      downloadTypeDialog: false,
      downloadType: 0,
      downloadTypeResolve: null,
    }
  },
  computed: {
    setTopClass() {
      return function (identityType) {
        if ([0, 2, 14, 6, 11, 18].indexOf(identityType) >= 0) {
          return "color:#eebb17"; //黄色
        } else if ([8, 10, 12, 16].indexOf(identityType) >= 0) {
          return "color:#1c9c1c"; //绿色
        } else {
          return "color:#e41313"; //红色
        }
      };
    },
  },
  methods: {
    handleClose() {
      this.downList.pageIndex = 1;
      this.downList.pageSize = 10;
      this.downList.data = [];
      this.submitLoading = false;
      this.uploadLoading = false;
      this.$emit('close')
    },
    getUser(e) {
      this.userListAllTable = e;
    },

    selectableFn(row) {
      if (row.status == 16) {
        return true
      } else {
        return false
      }
    },
    getRowKeys(val) {
      return val.id || "";
    },
    // 批量列表
    getQueryorderapplicants(downList) {
      this.downList = JSON.parse(JSON.stringify(downList))
      this.pageLoading = true;
      let vm = this;
      this.downList.pageSize = downList.pageSize
      queryorderapplicants({
        OrderId: downList.orderId,
        "Page.Size": downList.pageSize,
        "Page.Index": downList.pageIndex,
        orgQuery: true
      }).then((res) => {
        this.pageLoading = false;
        if (downList && this.downTitle == "批量提交") {
          this.downList.data = res.data.rows.filter((item) => {
            return (item.autoSubmitStatus == -1 || item.autoSubmitStatus == 0) && item.taskTable == 100;
          });
          this.downList.total = this.downList.data.length;
        } else if (downList && this.downTitle == "批量取消") {
          this.downList.data = res.data.rows.filter((item) => {
            return item.status == 10 || item.status == 20;
          });
          this.downList.total = this.downList.data.length;
        } else {
          this.downList.data = res.data.rows;
          this.downList.total = res.data.total;
        }
        this.downList.data = [...this.downList.data]
      }).catch(() => {
        this.pageLoading = false;
      });
    },
    // 点击确认
    confirmSubmit() {
      if (this.userListAllTable.length == 0) {
        this.$message({
          message: "未选择申请人！",
          type: "warning",
        });
        return;
      }

      if (this.downTitle == "批量取消") {
        this.batchCancel()
      } else if (this.downTitle == "发送邮件") {
        this.$prompt('输入邮箱', '发送邮件', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          inputErrorMessage: '邮箱格式不正确'
        }).then(({ value }) => {
          this.submitSendEmail(value)
        }).catch(() => { });
      } else if (this.downTitle == "批量提交") {
        // 批量提交
        this.batchSubmit(this.userListAllTable);
      } else if (this.downTitle == "导出名单") {
        // 批量提交
        this.batchExport(this.userListAllTable);
      }
    },

    //批量取消
    batchCancel() {
      let arr = [];
      this.userListAllTable.forEach((item) => {
        arr.push(item.id);
      });
      this.submitLoading = true;
      batchcancelvfsorder({ orderApplicantIds: arr }).then((res) => {
        console.log(res)
        if (res.code == 1) {
          this.$message({
            message: "批量取消成功！",
            type: "success",
          });
          this.applicantstatusTimer && clearInterval(this.applicantstatusTimer);

          this.handleClose();
          this.$emit('refresh');
        }
        this.submitLoading = false;
      }).catch(() => {
        this.submitLoading = false;
      })
    },

    // 发送邮件
    submitSendEmail(email) {

      let arr = [];
      this.userListAllTable.forEach((item) => {
        arr.push(item.id);
      });
      this.submitLoading = true;
      sendemailvisa({ orderApplicantIds: arr, email: email }).then((res) => {
        console.log(res)
        if (res.code == 1) {
          this.$message({
            message: "发送邮件成功！",
            type: "success",
          });
          this.applicantstatusTimer && clearInterval(this.applicantstatusTimer);

          this.handleClose();
          this.$emit('refresh');
        }
        this.submitLoading = false;
      }).catch(() => {
        this.submitLoading = false;
      })
    },


    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },

    downCurrentChange(e) {
      this.downList.pageIndex = e;

      this.getQueryorderapplicants(this.downList);
    },
    downSizeChange(e) {
      this.downList.pageSize = e;

      this.getQueryorderapplicants(this.downList);
    },
    selectDownloadType() {
      this.downloadType = 0;
      this.downloadTypeDialog = true;
      return new Promise((resolve, reject) => {
        this.downloadTypeResolve = { resolve, reject };
      });
    },
    confirmDownloadType() {
      this.downloadTypeDialog = false;
      if (this.downloadTypeResolve) {
        this.downloadTypeResolve.resolve(this.downloadType);
        this.downloadTypeResolve = null;
      }
    },
    cancelDownloadType() {
      this.downloadTypeDialog = false;
      if (this.downloadTypeResolve) {
        this.downloadTypeResolve.reject();
        this.downloadTypeResolve = null;
      }
    },
    submitDownLoadFn() {
      // this.userListAllTable = e;
      if (this.checkedCities.length == 0) {
        this.$message({
          message: "未选择下载内容！",
          type: "warning",
        });
        return;
      }

      if (this.userListAllTable.length == 0) {
        this.$message({
          message: "未选择申请人！",
          type: "warning",
        });
        return;
      }

      let obj = {
        visaPage: false,
        rejectLetter: false,
        bill: false,
        orderApplicantIds: [],
      };

      this.checkedCities.forEach((item) => {
        if (item == "收据页") {
          obj.bill = true;
        }

        if (item == "签证文件") {
          obj.visaPage = true;
        }

        if (item == "拒签信") {
          obj.rejectLetter = true;
        }
      });

      this.userListAllTable.forEach((item) => {
        obj.orderApplicantIds.push(item.id);
      });
      this.listLength = this.userListAllTable.length
      this.selectDownloadType().then(type => {
        this.uploadLoading = true
        const allIds = obj.orderApplicantIds;
        const chunkSize = 100;
        const chunks = [];
        for (let i = 0; i < allIds.length; i += chunkSize) {
          chunks.push(allIds.slice(i, i + chunkSize));
        }
        const that = this;
        let downloadedCount = 0;
        chunks.forEach((chunk, index) => {
          downloadapplicantsdata({
            ...obj,
            orderApplicantIds: chunk,
          }, type).then((res) => {
            downloadedCount++;
            if (res.data == null || res.data == "") {
              if (downloadedCount === chunks.length) {
                that.uploadLoading = false;
                if (downloadedCount === 1) {
                  that.$message({ message: "无可下载资料", type: "warning" });
                }
              }
            } else {
              let url = res.data;
              let x = new XMLHttpRequest();
              x.open("GET", url, true);
              x.responseType = "blob";
              x.onload = function () {
                let blobUrl = window.URL.createObjectURL(x.response);
                let a = document.createElement("a");
                a.href = blobUrl;
                if (!that.orderDetail.order.serviceMarks) {
                  a.download = `${that.orderDetail.order.orderNo}-(${chunk.length}人)-${that.orderDetail.order.visaTitle}-${(that.orderDetail.order.departureTime && that.$moment(new Date(that.orderDetail.order.departureTime)).format("YYYYMMDD"))}-${that.$moment(new Date()).format("YYYYMMDDHHmmss")}-${index + 1}`
                } else {
                  a.download = `${that.orderDetail.order.serviceMarks}-(${chunk.length}人)-${that.orderDetail.order.visaTitle}-${(that.orderDetail.order.departureTime && that.$moment(new Date(that.orderDetail.order.departureTime)).format("YYYYMMDD"))}-${that.$moment(new Date()).format("YYYYMMDDHHmmss")}-${index + 1}`
                }
                a.click();
                window.URL.revokeObjectURL(blobUrl);
                if (downloadedCount === chunks.length) {
                  that.uploadLoading = false;
                }
              };
              x.send();
            }
          }).catch(() => {
            downloadedCount++;
            if (downloadedCount === chunks.length) {
              that.uploadLoading = false;
            }
          });
        });
      }).catch(() => {
        this.uploadLoading = false
      });
    },
    batchSubmit() { // 批量提交
      if (this.userListAllTable.length == 0) {
        this.$message({
          message: "未选择申请人！",
          type: "warning",
        });
        return;
      }
      console.log(this.userListAllTable);
      //过滤已支付的列表
      const notPayList = this.userListAllTable.filter(item => item.isPay == 0)
      if (notPayList.length == 0) {
        this.$emit('confirm', this.isBatch, 1, this.userListAllTable)
      } else {
        // 选择支付方式提交大使馆
        this.submitApplicationShow = true;
      }
    },

    confirmSubmitFn(isBatch, payType) {//批量提交

      if (this.submitLoading) return
      this.submitLoading = true;
      setTimeout(() => {
        this.submitLoading = false;
      }, 3000);

      this.$emit('confirm', isBatch, payType, this.userListAllTable)
    },

    batchExport(userListAllTable) { // 批量导出 

      this.submitLoading = true;
      setTimeout(() => {
        this.submitLoading = false;
      }, 1500);
      const visaStatusObj = {
        [-1]: "已取消",
        0: "待填资料",
        2: "等待审核",
        3: "待提交领馆",
        4: "资料不完善",
        6: "等待送签",
        8: "要求面试",
        10: "提交中",
        12: "等待支付",
        14: "等待出签",
        16: "出签成功",
        17: "被拒签",
        18: "补充资料",
        20: "提交失败"
      }
      userListAllTable.forEach(item => {
        item.applicantNameEn = item.surnameEn + '/' + item.nameEn
        item.birthday = this.$moment(item.birthday).format("YYYY/MM/DD")
        item.passportIssue = this.$moment(item.passportIssue).format("YYYY/MM/DD")
        item.passportValidity = this.$moment(item.passportValidity).format("YYYY/MM/DD")
        item.phone = this.orderDetail && this.orderDetail.order && this.orderDetail.order.contactPhone
        item.statusName = visaStatusObj[item.status]
      })
      const tHeader = ['姓名', '全名拼音', '性别(男M女F)', '出生日期', '国籍', '护照号码', '护照签发日期', '护照有效期', '手机号码', '护照出生地', '护照签发地', '申请标号', '出签状态','支付信息'] // 表格头部
      const filterVal = ["applicantName", 'applicantNameEn', 'gender', 'birthday', 'passportCountryName', 'passportNumber', 'passportIssue', 'passportValidity', 'phone', 'provinceName', 'passportProvinceName', 'applyNumber', 'statusName','payUrl'] // 表格头部对应的数据字段名，用来过滤
      let excelTitle = ''
      try {
        excelTitle = `导出${this.orderDetail.order.orderNo}名单(${this.orderDetail.visaDetail.visa.countryName}-${this.orderDetail.visaDetail.visa.typeName})`
      } catch (error) {
        excelTitle = `导出${this.orderDetail.order.orderNo}名单`
      }
      const filename = excelTitle
      const data = this.formatJson(filterVal, userListAllTable)
      console.log(userListAllTable);


      // 文件数据处理完成后，会自动下载
      export_json_to_excel({
        header: tHeader,
        data,
        filename
      })
    },
    formatJson(filterVal, tableData) {
      return tableData.map((v) => {
        return filterVal.map((j) => {
          return v[j]
        })
      })
    },
  },
  watch: {
    userListAllTable: {
      handler(newVal, oldVal) {
        this.userListAllTableLength = newVal.length
      },
      deep: true,
      immediate: true,
    }
  }
}
</script>

<style lang="scss">
.dialog-wrap-dowm-nom {
  background: none !important;
  border-radius: 12px;

  .el-dialog {
    background: none;
  }

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    // width: 761px;

    // height: 285px;
    background: linear-gradient(180deg, #e7ecfb 0%, #f6f8fe 24%, #ffffff 100%);
    border-radius: 12px;
    box-sizing: border-box;
    overflow: hidden;
  }
}

.dialog-nom-list {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;

  .el-table {
    background: none;

    .el-table__row {
      background: none;

      .el-table__cell {
        padding: 6px 0;
      }
    }

    .el-table__header-wrapper {
      height: 36px;
      border-radius: 4px;

      .cell {
        line-height: 36px;
        height: 36px;
        margin-top: -10px;
      }
    }
  }

  .dialog-nom-list-left {
    width: 390px;
  }

  .dialog-nom-list-right {
    .dialog-nom-list-right-wrap {
      width: 295px;

      .dialog-nom-list-right-title {
        box-sizing: border-box;
        background: #fff;
        border-radius: 4px;
        height: 36px;
        display: flex;
        align-items: center;
        padding: 0 12px;
        justify-content: space-between;

        p {
          font-size: 12px;

          span {
            color: #0094e8;
          }
        }
      }

      .dialog-nom-list-right-yello {
        background: #fdf6ec;
        //  height: 28px;
        padding: 6px 12px;
        color: #f9c26f;
        box-sizing: border-box;
        font-size: 12px;
        margin-top: 8px;
      }

      .dialog-nom-select-up {
        margin-top: 15px;
      }
    }
  }
}
</style>